import React from 'react';

const STYLES = [
    "input-sm",
    "input-md",
    "input-lg"
];

const ALIGN = [
    "input-block",
    "input-flex"
];

type TabInputProps = {
    className?: string,
    label?: string,
    placeholder?: any,
    initValue?: number,
    variant: string,
    unit: string | void,
    align?: string,
    readOnly: boolean,
    property?: any,
    value?: string,
}

const TabInput = (props: TabInputProps) => {
    const {className, label, placeholder, initValue, variant, unit, align, readOnly, property} = props;
    const setInputStyle = STYLES.includes(variant) ? variant : STYLES[0];
    const setInputAlign = ALIGN.includes(align ?? '') ? align : ALIGN[0];

    return (
        <div className={`tab__input ${setInputAlign} ${className}`}>
            <span className='tab__input--label'>{label}</span>
            <div className={`tab__input--flex ${className}`}>
                <input
                    id={`input${property}`}
                    type='text'
                    className={`tab__input--field ${setInputStyle}`}
                    value={initValue || 0}
                    placeholder={placeholder}
                    readOnly={readOnly}
                />
                <span className='tab__input--unit'>{unit as string}</span>
            </div>
        </div>
    );
}

export default TabInput;